/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Count = {
    properties: {
        count: {
    type: 'number',
    isRequired: true,
},
    },
};